import "@mdxeditor/editor/style.css";

import {
  BoldItalicUnderlineToggles,
  headingsPlugin,
  listsPlugin,
  ListsToggle,
  MDXEditor,
  MDXEditorMethods,
  quotePlugin,
  toolbarPlugin,
  UndoRedo,
} from "@mdxeditor/editor";
import { Box, FormControl, FormHelperText } from "@mui/material";
import { useEffect, useRef } from "react";
import { Controller, useFormState, useWatch } from "react-hook-form";

export function RichTextFormField({
  name,
  disabled = false,
}: {
  name: string;
  disabled?: boolean;
}) {
  const { errors } = useFormState();
  const error = errors[name];
  const mdxEditorRef = useRef<MDXEditorMethods>(null);

  // TODO: When opening an initiative after editing a different one, the markdown doesnt get set to the new initiaties' markdown
  // Maybe a better solution?
  const value: string = useWatch({ name });
  useEffect(
    () => mdxEditorRef?.current?.setMarkdown(value ?? ""),
    [value, mdxEditorRef]
  );

  return (
    <FormControl sx={{ height: "100%" }} fullWidth>
      <Controller
        name={name}
        render={({ field }) => (
          <Box
            sx={(theme) => ({
              padding: "5px",
              border: `1px solid ${
                error ? theme.palette.error.main : "#0000003b"
              }`,
              borderRadius: "5px",
              backgroundColor: "#fff",
              "& ._toolbarRoot_uazmk_160": {
                backgroundColor: "white",
                position: "initial",
              },
            })}
          >
            <MDXEditor
              ref={mdxEditorRef}
              readOnly={disabled}
              markdown={field.value ?? ""}
              onChange={field.onChange}
              plugins={[
                toolbarPlugin({
                  toolbarContents: () => (
                    <>
                      <UndoRedo />
                      <BoldItalicUnderlineToggles />
                      <ListsToggle />
                    </>
                  ),
                }),
                headingsPlugin(),
                listsPlugin(),
                quotePlugin(),
              ]}
            />
            {error && (
              <FormHelperText
                sx={(theme) => ({ color: theme.palette.error.main })}
              >
                {error.message?.toString()}
              </FormHelperText>
            )}
          </Box>
        )}
      />
    </FormControl>
  );
}
